{
  "name": "eneza-web-client",
  "version": "1.3.2",
  "license": "UNLICENSED",
  "private": true,
  "scripts": {
    "ng": "ng",
    "build": "ng build client",
    "build:dev": "ng build client --aot --configuration development",
    "build:prod": "ng build client --aot --configuration production",
    "build:waitrose:dev": "ng build waitrose --aot --configuration development",
    "build:waitrose:prod": "ng build waitrose --aot --configuration production",
    "deploy": "firebase deploy",
    "deploy:dev": "firebase deploy -P dev",
    "deploy:prod": "firebase deploy -P prod",
    "deploy:beta": "firebase deploy --only hosting:beta -P prod",
    "deploy:client:dev": "firebase deploy --only hosting:client -P dev",
    "deploy:client:prod": "firebase deploy --only hosting:client -P prod",
    "deploy:waitrose:dev": "firebase deploy --only hosting:waitrose -P dev",
    "deploy:waitrose:prod": "firebase deploy --only hosting:waitrose -P prod",
    "start": "ng s client",
    "start:prod": "ng s client --configuration production",
    "start:waitrose": "ng s waitrose",
    "start:admin": "ng s admin",
    "prepare": "husky",
    "format": "prettier --write .",
    "format:check": "prettier --check .",
    "lint": "ng lint client",
    "lint:fix": "ng lint client --fix",
    "lint:fix:all": "npm run lint:fix && npm run format",
    "check:no-feature-settitle": "node scripts/check-no-feature-settitle.cjs",
    "check:param-route-title-tokens": "node scripts/check-param-route-title-tokens.cjs",
    "check:param-route-title-tokens:test": "node --test scripts/check-param-route-title-tokens.test.cjs",
    "check:no-angular-material": "node scripts/check-no-angular-material.cjs",
    "check:no-angular-material:test": "node --test scripts/check-no-angular-material.test.cjs",
    "ci:route-title-guard": "npm run check:no-feature-settitle && npm run check:param-route-title-tokens",
    "ci:no-angular-material": "npm run check:no-angular-material",
    "ci:guards": "npm run ci:route-title-guard && npm run ci:no-angular-material",
    "ci:missing-specs": "node scripts/list-missing-specs.cjs --kind=all --fail",
    "ci:unit-tests": "npm run test:ci && npm run ci:missing-specs",
    "lint:fix:changed": "node -e \"const {execSync}=require('node:child_process'); const files=execSync('git diff --name-only --diff-filter=ACMR',{encoding:'utf8'}).trim().split('\\n').filter(Boolean); const prettierFiles=files.filter(f=>/\\.(ts|html|css|scss|json|md|yml|yaml)$/.test(f)); if(prettierFiles.length){execSync('npx prettier --write '+prettierFiles.map(f=>JSON.stringify(f)).join(' '),{stdio:'inherit'});} else {console.log('No changed files for Prettier.');} const lintFiles=files.filter(f=>/\\.(ts|html)$/.test(f)); if(lintFiles.length){execSync('npx eslint --fix '+lintFiles.map(f=>JSON.stringify(f)).join(' '),{stdio:'inherit'});} else {console.log('No changed TS/HTML files for ESLint.');}\"",
    "lint:fix:staged": "node -e \"const {execSync}=require('node:child_process'); const files=execSync('git diff --cached --name-only --diff-filter=ACMR',{encoding:'utf8'}).trim().split('\\n').filter(Boolean); const prettierFiles=files.filter(f=>/\\.(ts|html|css|scss|json|md|yml|yaml)$/.test(f)); if(prettierFiles.length){execSync('npx prettier --write '+prettierFiles.map(f=>JSON.stringify(f)).join(' '),{stdio:'inherit'});} else {console.log('No staged files for Prettier.');} const lintFiles=files.filter(f=>/\\.(ts|html)$/.test(f)); if(lintFiles.length){execSync('npx eslint --fix '+lintFiles.map(f=>JSON.stringify(f)).join(' '),{stdio:'inherit'});} else {console.log('No staged TS/HTML files for ESLint.');}\"",
    "test": "ng test client",
    "test:ci": "NODE_OPTIONS=--max-old-space-size=3072 ng test client --watch=false",
    "test:ci:emulators": "NODE_OPTIONS=--max-old-space-size=3072 FIREBASE_TEST_MODE=emulator ng test client --watch=false",
    "test:coverage": "NODE_OPTIONS=--max-old-space-size=3072 ng test client --watch=false --coverage --coverage-reporters=text-summary",
    "test:coverage:gate": "mkdir -p coverage/client/.tmp && NODE_OPTIONS=--max-old-space-size=3072 ng test client --watch=false --configuration=coverage-gate",
    "check:missing-specs": "node scripts/list-missing-specs.cjs"
  },
  "lint-staged": {
    "*.{ts,html}": [
      "eslint --fix",
      "prettier --write"
    ],
    "*.{css,scss,json,md,yml,yaml}": [
      "prettier --write"
    ]
  },
  "dependencies": {
    "@angular/animations": "^22.1.2",
    "@angular/cdk": "^22.1.2",
    "@angular/common": "^22.1.2",
    "@angular/core": "^22.1.2",
    "@angular/forms": "^22.1.2",
    "@angular/google-maps": "^22.1.2",
    "@angular/platform-browser": "^22.1.2",
    "@angular/platform-browser-dynamic": "^22.1.2",
    "@angular/router": "^22.1.2",
    "@enezatelecoms/eneza-models": "^1.9.8",
    "@enezatelecoms/node-financejs": "^0.1.1",
    "@ng-select/ng-select": "^23.11.0",
    "@ngneat/dialog": "^5.2.1",
    "@ngneat/hot-toast": "^5.0.2",
    "@ngneat/overview": "^5.1.1",
    "@stripe/stripe-js": "^9.13.0",
    "core-js": "^3.50.0",
    "creditcard.js": "^3.0.64",
    "csvtojson": "^2.0.10",
    "expr-eval": "^2.0.2",
    "file-saver": "^2.0.5",
    "firebase": "^11.10.0",
    "google-libphonenumber": "^3.2.46",
    "highcharts": "^13.0.0",
    "highcharts-angular": "^5.4.1",
    "js-md5": "^0.9.2",
    "jszip": "^3.10.1",
    "moment": "^2.29.3",
    "ngx-chips": "^3.0.0",
    "ngx-editor": "^19.0.0-beta.1",
    "pdfmake": "^0.3.11",
    "rxfire": "^6.2.0",
    "rxjs": "^7.5.7",
    "sweetalert2": "^11.26.25",
    "tslib": "^2.4.0",
    "uuid": "^14.0.1",
    "xlsx": "^0.18.5",
    "zone.js": "^0.16.2"
  },
  "devDependencies": {
    "@angular-devkit/architect": "^0.2201.4",
    "@angular-eslint/builder": "^22.1.0",
    "@angular-eslint/eslint-plugin": "^22.1.0",
    "@angular-eslint/eslint-plugin-template": "^22.1.0",
    "@angular-eslint/schematics": "^22.1.0",
    "@angular-eslint/template-parser": "^22.1.0",
    "@angular/build": "^22.1.4",
    "@angular/cli": "^22.1.4",
    "@angular/compiler": "^22.1.2",
    "@angular/compiler-cli": "^22.1.2",
    "@angular/language-service": "^22.1.2",
    "@eslint/js": "^10.0.1",
    "@tailwindcss/forms": "^0.5.3",
    "@tailwindcss/postcss": "^4.3.3",
    "@types/file-saver": "^2.0.5",
    "@types/pdfmake": "^0.3.3",
    "@types/uuid": "^11.0.0",
    "@vitest/coverage-v8": "^4.1.10",
    "angular-eslint": "^22.1.0",
    "eslint": "^10.8.1",
    "eslint-config-prettier": "^10.1.8",
    "eslint-plugin-prettier": "^5.5.6",
    "first-input-delay": "^0.1.3",
    "husky": "^9.1.7",
    "istanbul-lib-instrument": "^6.0.3",
    "jsdom": "^30.0.1",
    "lint-staged": "^17.3.0",
    "open": "^11.0.1",
    "postcss": "^8.5.3",
    "prettier": "^3.9.6",
    "prettier-eslint": "^17.1.1",
    "prettier-plugin-organize-imports": "^4.3.0",
    "prettier-plugin-tailwindcss": "^0.8.1",
    "tailwindcss": "^4.3.3",
    "typescript": "~6.0.3",
    "typescript-eslint": "^8.67.0",
    "vitest": "^4.0.8"
  }
}
